export default __webpack_public_path__ + "static/media/10.960c8a21.jpg";